import React from "react";
import { Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import productOne from "../../assets/img/herbalProduct.webp";
import category2Image from "../../assets/img/yogaProduct.webp";

const titleStyles = {
  fontSize: ".9em",
};

export default function ProductLayout() {
  const productData = [
    {
      path: "/herbalProduct",
      img: productOne,
      title: "Category 1",
    },
    {
      path: "/yoga",
      img: category2Image,
      title: "Category 2",
    },
  ];
  return (
    <>
      {productData.map((data, index) => {
        return (
          <Col className="col-md" key={index + "product"}>
            <div className="card h-100 ">
              <Link to={data.path}>
                <img
                  src={data.img}
                  className="card-img-top"
                  alt="vebbox products"
                  style={{height:"170px"}}
                />
              </Link>
              <div className="card-body">
                <Link
                  to={data.path}
                  className="h6 text-decoration-none text-uppercase text-dark productTitle"
                  style={titleStyles}>
                  {data.title}
                </Link>
              </div>
            </div>
          </Col>
        );
      })}
    </>
  );
}
